import React, { useRef, useState, useEffect, useContext, useMemo } from "react";
import "./AccessCodeUserDetails.scss";
import { registerAccessCode } from '../../network/ApiService';
import { Input, Button, Loader, IESAuthUtilV2 } from "@activehub/common-components-spa-resource";
import { useAccessCodeUserDetails } from "./useAccessCodeUserDetails";
// import { use } from "react";
import { IESConfig, IESOptions } from '../../constants/IESConfig';
import {
  ErrorPopUp
} from "../../components";

const AccessCodeUserDetails = (props) => {
  const [iesSession, setIesSession] = useState(null);
  const [errorMsg, setErrMsg] = useState('')
  const [openErrorPopup, setOpenErrorPopup] = useState(false)
  const {
    formValues,
    handleInput,
    handleClearEmail,
    emailValidation,
    firstNameValidation,
    lastNameValidation,
    registerUser,
    isRequiredFormDataFilled,
    isDirtyForm,
    hasValidationErrors,
     errMsgTooltip, 
    setErrMsgTooltip,
    isEmailValidated,
    showEmailSuccess,
    emailErrorType,
    isFirstnameValidated,
    fnameErrorType,
    isLastnameValidated,
    lnameErrorType,
    isSearchLoading,
    isCreatingUser,
    isExistingUser,
    fieldInteractionState,
    setFieldInteractionState,
    updateValidation
  } = useAccessCodeUserDetails();

  const [isLoading, setIsLoading] = useState(false)

  const setClient = (e) => {
    sessionStorage.setItem("LOGINTYPE", e.target.id)
    iesSession.login();
  }
 
  // Show browser confirmation dialog when user tries to refresh/leave page with unsaved data
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirtyForm) {
        const message = "If you leave this page now, your information will be lost. To complete registration, stay on this page and click 'Finish and register'.";
        event.preventDefault();
        event.returnValue = message; // Required for Chrome
        return message; // Required for other browsers
      }
    };
 
    window.addEventListener('beforeunload', handleBeforeUnload);
 
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirtyForm]);

  // Hide tooltip when clicking anywhere in the application
  useEffect(() => {
    const handleClickAway = () => {
      if (errMsgTooltip) {
        setErrMsgTooltip(false);
      }
    };

    document.addEventListener('click', handleClickAway);

    return () => {
      document.removeEventListener('click', handleClickAway);
    };
  }, [errMsgTooltip, setErrMsgTooltip]);

  // Hide tooltip when loading starts
  useEffect(() => {
    if (isLoading || isSearchLoading) {
      setErrMsgTooltip(false);
    }
  }, [isLoading, isSearchLoading, setErrMsgTooltip]);

useEffect(() => {
        const userIdKey = Object.keys(localStorage).find(key => key.includes('PiUserId'))
        const successUrl = window.location.href.includes('/login') ? window.location.href.split("#")[0] : window.location.href;
        if (localStorage.getItem(userIdKey)) {
            window.location.assign(successUrl);
        }
        const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
        const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
        const iesSubscription = IESAuthUtilV2.load({
            ...IESConfig,
            callbackURL: window.location.origin,
            domain: window.location.hostname,
            ...loginParams
        }, IESOptions).subscribe((session) => {
            console.count("IES Session")
            setIesSession(session);
        });

        return () => iesSubscription.unsubscribe();
    }, []);


const handleFinishAndRegister = () => {
    // If parent component handles the next step
    if (
      formValues.email === "" ||
      formValues.firstname === "" ||
      formValues.lastname === ""
    ) {
      formValues.email  === "" && updateValidation(false);
      setFieldInteractionState(prev => ({
            ...prev,
            email: { hasContent: false, showErrors: true }
          }));
      emailValidation(null, true);
      firstNameValidation(null, true);
      lastNameValidation(null, true);
      
      // Show tooltip only if all fields are empty (no specific field validation errors to show)
      const allFieldsEmpty = formValues.email === "" && formValues.firstname === "" && formValues.lastname === "";
      setErrMsgTooltip(allFieldsEmpty);
      return;
    } else {
      setErrMsgTooltip(false);
      // Otherwise, register the user directly
      //   registerUser();
      submitRegister();
    }
  };

  const submitRegister = () => {
    let payload = {
      userName: formValues?.username,
      firstName: formValues?.firstname,
      lastName: formValues?.lastname,
      emailId: formValues?.email,
      role : "Learner",
      yearGroup: "Year 7",
      userAvailableInIES:true
    }
    setIsLoading(true)
    registerAccessCode([payload], props?.accessCode).subscribe(
      (response) => {
        props.onNextStep(formValues);
        setIsLoading(false)
      },
      (error) => {
        if((error?.data?.status == 404 && error?.data?.detail == 'INTEGRATION_API_ERROR') || error?.data?.status == 500) {
          setErrMsg("Oops! Something went wrong. Please try again after sometime.");
        }else {
          setErrMsg(error?.data?.detail || error?.data?.message)
        }    
        setOpenErrorPopup(true);
        setIsLoading(false)
      }
    );
  }

  return (
    <div className="access-code-user-details">
      <ErrorPopUp
        popupType="error"
        isOpen={openErrorPopup}
        headerText={`Error`}
        bodyText={errorMsg}
        closeButton={"Close"}
        handleCloseButton={()=>setOpenErrorPopup(false)}
      />
      <div
        className="user-details-breadcrumb"
        onClick={() => props.onBackStep(props?.accessCode, props?.ebookTitle)}
      >
        <div className="symbol">
          <img
            src={`${process.env.PUBLIC_URL}/images/breadcrumb-lesser-icon.svg`}
            width="10"
            height="10"
            alt="lesser icon"
          />
          <span>Back to enter access code</span>
        </div>
      </div>
      <div>
        <h4>Enter your details</h4>
        <form>
          <div className="input-row">
            <span className="required-text">All fields are required.</span>
            <div className="col-md-10 mt-3">
              <div className="email-input-wrapper">
                <Input
                  inputtype={"text"}
                  title={
                    <>
                      <label>Email address</label>
                      <div className="d-block email-info">
                        <div>
                          This will be the email address used to log into your
                          account.
                        </div>
                        <div>It should be a school email if you have one.</div>
                      </div>
                    </>
                  }
                  name={"email"}
                  value={formValues.email}
                  placeholder={"Email address"}
                  onChange={handleInput}
                  frmgrpclsname={"mb-0"}
                  onBlur={emailValidation}
                  customDataAttributes={{
                    "data-id": "email",
                    "data-type": "value",
                    autocomplete: "email",
                    "aria-required": true,
                  }}
                  isInValid={fieldInteractionState.email.showErrors && !isEmailValidated && !showEmailSuccess}
                  invalidText={fieldInteractionState.email.showErrors && !showEmailSuccess ? emailErrorType : ""}
                  inputClassName={`user-details-email-field ${
                    fieldInteractionState.email.showErrors && !isEmailValidated
                      ? "is-invalid"
                      : showEmailSuccess && !isSearchLoading
                      ? "is-valid"
                      : ""
                  } email-input-with-clear`}
                  required={true}
                  customAria="Email address"
                />
                 {fieldInteractionState.email.showErrors && !isEmailValidated && formValues.email && (
                    <button
                    type="button"
                    className="email-clear-button"
                    onClick={handleClearEmail}
                    aria-label="Clear email"
                    >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/email-clear-icon.svg`}
                      width="12"
                      height="12"
                      alt="Clear email"
                    />
                  </button>
                  )}
                  {(isSearchLoading || isLoading) && (
                    <div className="email-field-loader">
                      <div className="spinner"></div>
                    </div>
                )}
                {showEmailSuccess && !isLoading && !isSearchLoading && (
                    <div className="custom-success-message">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/email-success-icon.svg`}
                      width="16"
                      height="16"
                      alt="Valid email"
                    />
                    This is a valid email
                  </div>
                )}
              </div>
            </div>
            {!isExistingUser && <div>
            <div className="col-md-7">
              <Input
                inputtype={"text"}
                title={"First name"}
                name={"firstname"}
                value={formValues.firstname}
                placeholder={"First name"}
                onChange={handleInput}
                customDataAttributes={{
                  "data-id": "firstname",
                  "data-type": "value",
                  autocomplete: "given-name",
                  "aria-required": true,
                }}
                required={true}
                onBlur={firstNameValidation}
                inputClassName={`user-detials-name-field ${fieldInteractionState.firstname.showErrors && !isFirstnameValidated ? "is-invalid" : ""}`}
                isInValid={fieldInteractionState.firstname.showErrors && !isFirstnameValidated && !isExistingUser}
                invalidText={isExistingUser ? "" : (fieldInteractionState.firstname.showErrors ? fnameErrorType : "")}
              />
            </div>
            <div className="col-md-7">
              <Input
                inputtype={"text"}
                title={"Last name"}
                name={"lastname"}
                value={formValues.lastname}
                placeholder={"Last name"}
                onChange={handleInput}
                frmgrpclsname={"mb-4"}
                customDataAttributes={{
                  "data-id": "lastname",
                  "data-type": "value",
                  autocomplete: "family-name",
                  "aria-required": true,
                }}
                required={true}
                onBlur={lastNameValidation}
                inputClassName={` user-detials-name-field ${fieldInteractionState.lastname.showErrors && !isLastnameValidated ? "is-invalid" : ""}`}
                isInValid={fieldInteractionState.lastname.showErrors && !isLastnameValidated && !isExistingUser}
                invalidText={isExistingUser ? "" : (fieldInteractionState.lastname.showErrors ? lnameErrorType : "")}
              />
              {errMsgTooltip && !isLoading && !isSearchLoading && <span className={`err-msg-tooptip`}>Please enter your details to continue</span>}
            </div>
            </div>
            }
          </div>
        </form>
        <Button
          className={` next-step`}
          tabIndex={!isRequiredFormDataFilled ? -1 : 0}
          onClick={handleFinishAndRegister}
          isDisabled={isExistingUser ? showEmailSuccess? false : true :  hasValidationErrors}
        >
          Finish and register
          <img
            src={`${process.env.PUBLIC_URL}/images/greater-${
             (isExistingUser ? showEmailSuccess? false : true :  hasValidationErrors )? `grey` : `white`
            }-icon.svg`}
            width="10"
            height="10"
            alt="img"
          />
        </Button>
        <Button
          className="access-code-sign-in"
          tabIndex={true ? 0 : -1}
          onClick={setClient}
        >
          Already have an account? Sign in
        </Button>
      </div>
    </div>
  );
};

export default AccessCodeUserDetails;
